import WidgetClassContentItemModelBase from '../_generated/modelBases/widget-class-content-item-model-base';

export default class WidgetClassContentItemModel extends WidgetClassContentItemModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
